module.exports = __webpack_public_path__ + "static/media/stripe.06a084ff.png";